module.exports = __webpack_public_path__ + "static/media/pos.580f11c1.svg";